import React from "react";
import { View, Text, Platform, Pressable, StyleSheet } from "react-native";

type LegalPage = "terms" | "privacy" | "dmca" | "about" | "contact";

interface FooterProps {
  onLegalPageRequest?: (
    page: "terms" | "privacy" | "dmca" | "about" | "contact",
  ) => void;
}

export const Footer: React.FC<FooterProps> = ({ onLegalPageRequest }) => {
  const handleLegalLinkPress = (
    page: "terms" | "privacy" | "dmca" | "about" | "contact",
  ) => {
    if (Platform.OS === "web") {
      // For web, open in new tab
      const urls = {
        terms: "/terms",
        privacy: "/privacy",
        dmca: "/dmca",
        about: "/about",
        contact: "/contact",
      };
      window.open(urls[page], "_blank");
    } else {
      // For native, use the callback
      onLegalPageRequest?.(page);
    }
  };

  const links: { page: LegalPage; label: string }[] = [
    { page: "terms", label: "Terms" },
    { page: "privacy", label: "Privacy" },
    { page: "about", label: "About" },
    { page: "contact", label: "Contact" },
  ];

  return (
    <View style={styles.container}>
      <Text style={styles.copyright}>
        © 2025–2026 Galaxy Brain Entertainment
      </Text>
      <View style={styles.linkRow}>
        {links.map(({ page, label }, i) => (
          <React.Fragment key={page}>
            {i > 0 && (
              <Text style={styles.separator} accessibilityElementsHidden>
                •
              </Text>
            )}
            <Pressable
              onPress={() => handleLegalLinkPress(page)}
              accessibilityRole="link"
              style={styles.link}
            >
              <Text style={styles.linkText}>{label}</Text>
            </Pressable>
          </React.Fragment>
        ))}
      </View>
    </View>
  );
};

// #8A8A8A on the #121212 page is 5.4:1 (AA for small text); no opacity layers.
const FOOTER_TEXT = "#8A8A8A";

const styles = StyleSheet.create({
  container: {
    paddingHorizontal: 12,
    paddingTop: 8,
    paddingBottom: 4,
    backgroundColor: "transparent",
    alignItems: "center",
  },
  copyright: {
    fontSize: 11,
    color: FOOTER_TEXT,
  },
  linkRow: {
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    flexWrap: "nowrap",
  },
  separator: {
    fontSize: 11,
    color: FOOTER_TEXT,
  },
  link: {
    paddingVertical: 12,
    paddingHorizontal: 6,
  },
  linkText: {
    fontSize: 12,
    color: FOOTER_TEXT,
  },
});
